"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = require("react");

var _context = require("../../context");

var _constants = require("../../form/constants");

var _utils = require("../../utils");

var _constants2 = require("./constants");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var areEqual = function areEqual(prev, next) {
  return prev.isOpen === next.isOpen && prev.isInTopPlacement === next.isInTopPlacement && prev.children === next.children;
};

var DropdownWrapper = /*#__PURE__*/(0, _react.memo)((0, _context.styledWithTheme)('div')(function (_ref) {
  var theme = _ref.theme,
      isOpen = _ref.isOpen,
      width = _ref.width,
      maxHeight = _ref.maxHeight,
      height = _ref.height,
      isInTopPlacement = _ref.isInTopPlacement,
      isAlwaysOpened = _ref.isAlwaysOpened,
      borderRadius = _ref.borderRadius;
  return _objectSpread(_objectSpread(_objectSpread({
    display: 'flex',
    flexDirection: 'column',
    maxHeight: maxHeight,
    height: height,
    width: width,
    // fixes border-radius issue in Safari
    isolation: 'isolate',
    // Remove the border when not open, because the dropdown always has to
    // be mounted for downshift to work correctly.
    border: "".concat(_constants2.BORDER_WIDTH, "px solid ").concat(isOpen ? theme.selectors.color(_constants2.BORDER_COLOR) : 'transparent'),
    // Remove the top border so that the border of the trigger element
    // shows through instead, if in top placement show the top border
    borderTopColor: isOpen && isInTopPlacement ? theme.selectors.color(_constants2.BORDER_COLOR) : 'transparent',
    // Remove the bottom border if the dropdown is opened in the top position so the trigger element shows through
    borderBottomColor: isOpen ? isInTopPlacement ? 'transparent' : theme.selectors.color(_constants2.BORDER_COLOR) : 'transparent',
    // Also remove the shadow when not open
    boxShadow: isOpen ? "0 0 10px 0 ".concat((0, _utils.opacify)(theme.selectors.color(_constants2.SHADOW_COLOR), _constants2.SHADOW_OPACITY)) : 'none'
  }, isAlwaysOpened && {
    border: 0,
    boxShadow: 'none'
  }), {}, {
    overflow: 'hidden'
  }, (0, _utils.getBorderRadiusStyle)(theme.selectors.radius, borderRadius || 0)), isOpen && {
    ':before': _objectSpread(_objectSpread({
      width: "calc(".concat(isInTopPlacement ? '50' : '100', "% - 2px)"),
      content: '""',
      height: '4px',
      background: theme.selectors.color(_constants.DEFAULT_BACKGROUND_COLOR),
      position: 'absolute'
    }, isInTopPlacement ? {
      bottom: '1px'
    } : {
      top: '1px'
    }), {}, {
      left: 0,
      borderLeft: "".concat(_constants2.BORDER_WIDTH, "px solid ").concat(theme.selectors.color(_constants2.BORDER_COLOR)),
      borderRight: "".concat(_constants2.BORDER_WIDTH, "px solid ").concat(theme.selectors.color(_constants2.BORDER_COLOR))
    })
  });
}), areEqual);
DropdownWrapper.displayName = 'DropdownWrapper';
var _default = DropdownWrapper;
exports.default = _default;